import React, { useEffect } from 'react'
import Navbar from '../Homepage/Navbar/Navbar'
import Banner from './Banner/Banner'
import Program from './Program/Program'
import Circle from './Circle/Circle'
import Footer from '../Homepage/footer/Footer'
import { useTheme } from '../../contexts/ThemeProvider'
import SEO from '../SEO'
import Agents from './Agents/Agents'
import Rainsdk from './Rainsdk/Rainsdk'
import Journey from './Journey/Journey'

const Builders = () => {
  const { theme, toggle } = useTheme();

  useEffect(() => {
    if (theme !== "dark") {
      toggle();
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    document.body.classList.add("builder-page-body");
    return () => {
      document.body.classList.remove("builder-page-body");
    };
  }, []);
  return (
    <>
      <SEO
        url='https://www.rain.one/builders'
      />
      <Navbar />
      <Banner />
      <Agents/>
      <Rainsdk/>
      <Journey/>
      <Program />
      <Circle />
      <Footer />
    </>
  )
}

export default Builders
